/*
 * Copyright (c) 2019 by Felix Heim, felix-heim@web.de
 *
 * This product includes software developed at
 * The Apache Software Foundation (http://www.apache.org/).
 */

(function() {
    'use strict';

    angular
        .module('askApp')
        .controller('StatisticsController', StatisticsController);

    StatisticsController.$inject = ['DateUtils', 'Principal', 'ParseLinks', '$http', 'AlertService', '$state', 'calendarConfig', 'moment'];

    function StatisticsController(DateUtils, Principal, ParseLinks, $http, AlertService, $state, calendarConfig, moment) {
        var vm = this;
        vm.viewChanged = viewChanged;
        vm.birthdates = [];
        vm.birthdatesList = [];
        for(var i = 0; i < 12; i++) {
            vm.birthdatesList.push([]);
        }
        vm.birthdateView = 'month';
        vm.birthdateDate = new Date();

        calendarConfig.i18nStrings.weekNumber = 'KW {week}';
        moment.locale("de", {
            week: {
                dow: 1
            }
        });

        viewChanged();
        getManagerOverview();


        vm.birthdayClicked = function(birthday) {
            $state.go('member-management-detail', {'id': birthday.id});
        };

        function getBirthdays(month) {
            if (vm.birthdatesList[month].length !== 0) {
                setViewToMonth(month);
                return;
            }
            $http.get('api/board/statistics/birthday/' + (month + 1), {}).then(function(response) {
                var data = response.data;

                for(var i = 0; i < data.length; i++) {
                    data[i].birthdate = DateUtils.convertDateTimeFromServer(data[i].birthdate);
                    var fromTime = angular.copy(data[i].birthdate);
                    fromTime.setFullYear(new Date().getFullYear());
                    fromTime.setHours(0);
                    var age = fromTime.getFullYear() - data[i].birthdate.getFullYear();

                    for(var offset = -1; offset <= 1; offset++) {
                        var displayAge = age + offset;
                        if(displayAge < 0) {
                            continue;
                        }
                        if(displayAge === 0) {
                            displayAge = "*";
                        }

                        var startDateCopy = angular.copy(fromTime);
                        var birthday = {
                            title: data[i].firstName + " " + data[i].lastName + (data[i].nickname ? (' &quot;' + data[i].nickname + '&quot;') : ('')) + " (" + displayAge + ")",
                            id: data[i].id,
                            startsAt: new Date(startDateCopy.setFullYear(fromTime.getFullYear() + offset)),
                            allDay: true,
                            color: {
                                primary: "#ffffff",
                                secondary: "#ffffff"
                            }
                        };
                        vm.birthdatesList[month].push(birthday);
                    }
                }
                setViewToMonth(month);
            });
        }

        function setViewToMonth(month) {
            vm.birthdates = vm.birthdatesList[month];
        }

        function viewChanged() {
            getBirthdays(vm.birthdateDate.getMonth());
        }

        function getManagerOverview() {
            $http.get('api/board/profiles/manager/overview', {}).then(function(response) {
                vm.managerOverview = response.data;
            });
        }

        Principal.identity().then(function(account) {
            vm.currentAccount = account;
        });
    }
})();
